import React from 'react';
import { motion } from 'framer-motion'
import { fadeIn } from '../../constants/variants';
import { SubHeading } from '../../components';
import { images } from '../../constants';
import Typed from 'react-typed'
import './Header.css';


const Header = () => (
  <div 
    className="app__header app__wrapper section__padding" id="home">
    <motion.div 
        variants={fadeIn('right')}
        initial='hidden'
        whileInView={'show'}
        viewport={{ once: false, amount: 0.6 }}
        className="app__wrapper_info">
      <SubHeading title="Chase the new flavour" />
      <h1 className="app__header-h1">The Key To Fine</h1>
      <Typed
        className='app__header-h1'
        strings={['Dining']} 
        typeSpeed={120}
        backSpeed={140}
        loop
      />
      <p className="p__opensans" style={{ margin: '2rem 0' }}>It's a bit more expensive but it is a chance for you to experience a memorable meal which you can't find in other normal restaurant.</p>
      <button type="button" className="custom__button">Explore Menu</button>
    </motion.div>

    <motion.div 
    variants={fadeIn('left')}
    initial='hidden'
    whileInView={'show'}
    viewport={{ once: false, amount: 0.6 }}
      className="app__wrapper_img">
      <img src={images.welcome} alt="header_img" />
    </motion.div>
  </div>
);

export default Header;
